import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Pagination } from "@mui/material";
import { makeStyles } from "@mui/styles";
import axios from "axios";
import { PermissionManagementContext } from "pages/system-management/permission-management/index";
import React, { useContext, useEffect, useState } from "react";
import { DelayInput } from "react-delay-input";

const useStyles = makeStyles((theme) => ({
  deleteItemButton: {
    background: "none",
    border: "none",
    padding: 0,
    "min-width": "15px",
    "&:hover": {
      background: "none",
    },
    "& span": {
      width: "auto",
    },
    "& img": {
      width: "15px",
    },
  },
}));

export default function PermissionManagementList(props) {
  const classes = useStyles();
  const { loadList, params, managerRoleList } = useContext(
    PermissionManagementContext
  );
  const [schParams, setSchParams] = useState(params);

  const [openModal, setOpenModal] = useState(false);
  const [modalMode, setModalMode] = useState("");
  const [delSeq, setDelSeq] = useState("");

  useEffect(() => {
    // loadList();
    // setTimeout(() => {
    //   loadList();
    // }, 500);
    // setTimeout(() => {
    //   loadList();
    // }, 1000);
  }, []);

  useEffect(() => {
    loadList(schParams);
  }, [schParams]);

  if (!managerRoleList) return <></>;

  managerRoleList.list.map((item, i) => {
    item.id = item.seq;
    item.index = i;
  });

  const columns = [
    {
      field: "no",
      headerName: "NO",
      headerAlign: "center",
      sortable: false,
      width: 80,
      disableColumnMenu: true,
      valueGetter: (params) => {
        return `${managerRoleList.number - params.row.index}`;
      },
    },
    {
      field: "nm",
      headerName: "역할명",
      headerAlign: "center",
      sortable: false,
      flex: 1,
      disableColumnMenu: true,
    },
    {
      field: "useYn",
      headerName: "사용여부",
      headerAlign: "center",
      align: "left",
      sortable: false,
      flex: 1,
      disableColumnMenu: true,
      renderCell: (params) => <p>{params.value == "Y" ? "사용" : "미사용"}</p>,
    },
    {
      field: "formatRgstYmd",
      headerName: "등록일",
      headerAlign: "center",
      sortable: false,
      flex: 1,
      disableColumnMenu: true,
    },
    {
      field: "rgstrNm",
      headerName: "등록자",
      headerAlign: "center",
      sortable: false,
      flex: 1,
      disableColumnMenu: true,
    },
    {
      field: "func",
      headerName: "기능",
      headerAlign: "center",
      align: "center",
      sortable: false,
      editable: false,
      width: 70,
      disableColumnMenu: true,
      renderCell: (props) => (
        <div>
          <Button
            className={classes.deleteItemButton}
            size="small"
            color="primary"
            variant="contained"
            onClick={(e) => {
              e.stopPropagation();
              handleModalOpen("delete", props.row);
            }}
          >
            <img src="/images/icon/remove_item.png" alt="삭제 아이콘" />
          </Button>
        </div>
      ),
    },
  ];
  const handleRegist = (e) => {
    console.log("e: ", e);
    props.history.push("/system-management/permission-management/regist");
  };

  const handleModalOpen = (mode, item) => {
    setModalMode(mode);
    setOpenModal(true);
    if (mode == "delete") {
      setDelSeq(item.seq);
    }
  };

  const handleDelete = (e) => {
    axios
      .post("/api/st/manager-role/remove", null, {
        params: {
          seq: delSeq,
        },
      })
      .then((res) => {
        setModalMode("delete");
        handleModalOpen("complete");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleModalClose = () => {
    setOpenModal(false);
  };

  return (
    <>
      <div className="h-group">
        <h2 className="h2">관리자권한관리</h2>
      </div>

      <table className="table">
        <colgroup>
          <col style={{ width: "15%" }} />
          <col style={{ width: "35%" }} />
          <col style={{ width: "15%" }} />
          <col style={{ width: "35%" }} />
        </colgroup>
        <tbody>
          <tr>
            <th scope="row">
              <InputLabel htmlFor="searchRange">사용여부</InputLabel>
            </th>
            <td colSpan="3">
              <RadioGroup
                defaultValue=""
                row
                onChange={(e) => {
                  setSchParams({
                    ...schParams,
                    schUseYn: e.target.value,
                  });
                }}
              >
                <FormControlLabel
                  value=""
                  control={
                    <Radio
                      color="primary"
                      icon={<span className="radio-icon" />}
                      checkedIcon={<span className="radio-icon-checked" />}
                    />
                  }
                  label="전체"
                />
                <FormControlLabel
                  value="Y"
                  control={
                    <Radio
                      color="primary"
                      icon={<span className="radio-icon" />}
                      checkedIcon={<span className="radio-icon-checked" />}
                    />
                  }
                  label="사용"
                />
                <FormControlLabel
                  value="N"
                  control={
                    <Radio
                      color="primary"
                      icon={<span className="radio-icon" />}
                      checkedIcon={<span className="radio-icon-checked" />}
                    />
                  }
                  label="미사용"
                />
              </RadioGroup>
            </td>
          </tr>
          <tr>
            <th scope="row">
              <InputLabel htmlFor="keyword">키워드 검색</InputLabel>
            </th>
            <td colSpan="3">
              <Grid container spacing={1}>
                <Grid item xs={1}>
                  <Select
                    id="keyword"
                    value={schParams.schFld}
                    fullWidth
                    onChange={(e) => {
                      setSchParams({
                        ...schParams,
                        schFld: e.target.value,
                      });
                    }}
                    MenuProps={{
                      anchorOrigin: {
                        vertical: 30,
                        horizontal: "left",
                      },
                      transformOrigin: {
                        vertical: "top",
                        horizontal: "left",
                      },
                      getContentAnchorEl: null,
                    }}
                  >
                    <MenuItem value={"whle"}>전체</MenuItem>
                    <MenuItem value={"mr_cont"}>역할명</MenuItem>
                    <MenuItem value={"mr_nm"}>등록자</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={11}>
                  <div className="MuiInputBase-root MuiInput-root MuiInputBase-fullWidth MuiInput-fullWidth">
                    <DelayInput
                      name="schTxt"
                      placeholder="검색어를 입력해주세요."
                      fullWidth
                      id="standard-basic"
                      delayTimeout={500}
                      className="MuiInputBase-input MuiInput-input"
                      value={schParams.schTxt}
                      onChange={(e) => {
                        setSchParams({
                          ...schParams,
                          schTxt: e.target.value,
                        });
                      }}
                    />
                  </div>
                </Grid>
              </Grid>
            </td>
          </tr>
        </tbody>
      </table>

      <Grid container className="inline-form">
        <Grid item xs={6}>
          <div className="total-count-wrap">
            <span>Total</span>
            <span className="color-primary">{managerRoleList.totalSize}</span>
          </div>
        </Grid>
        <Grid item xs={6} className="inner-form-wrap">
          <Box display="flex" justifyContent="end">
            <FormControl className="MuiFormControl-wrap">
              <Select
                value={schParams.pgSz}
                onChange={(e) => {
                  setSchParams({
                    ...schParams,
                    pgSz: e.target.value,
                  });
                }}
                MenuProps={{
                  anchorOrigin: {
                    vertical: 30,
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                  getContentAnchorEl: null,
                }}
              >
                <MenuItem value={10}>10개씩</MenuItem>
                <MenuItem value={20}>20개씩</MenuItem>
                <MenuItem value={30}>30개씩</MenuItem>
                <MenuItem value={50}>50개씩</MenuItem>
                <MenuItem value={100}>100개씩</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </Grid>
      </Grid>

      <DataGrid
        className="selectable"
        headerHeight={32}
        rowHeight={32}
        autoHeight
        row
        rows={managerRoleList.list}
        columns={columns}
        pageSize={schParams.pgSz}
        disableSelectionOnClick
        onRowClick={(GridRowParams) => {
          // console.log("click", GridRowParams);
          props.history.push(
            `/system-management/permission-management/regist/${
              GridRowParams.row.seq
            }`
          );
        }}
        components={{
          NoRowsOverlay: () => (
            <div className="nodata-wrap">
              검색 결과 값이 없습니다. 다시 검색해주세요.
            </div>
          ),
        }}
      />

      <div className="bottom-area">
        <Box display="flex" justifyContent="center" m={1} p={1}>
          <Pagination
            page={schParams.pg}
            count={managerRoleList.totalPageSize}
            color="primary"
            size="small"
            className="mt-2"
            onChange={(e, value) => {
              setSchParams({
                ...schParams,
                pg: value,
              });
            }}
          />
        </Box>
        <Button
          variant="contained"
          color="primary"
          className="btn-write"
          size="sm"
          onClick={handleRegist}
        >
          등록
        </Button>
      </div>

      <Dialog
        id="alert-dialog"
        fullWidth={true}
        open={openModal}
        className="alert-dialog"
        onClose={handleModalClose}
        aria-labelledby="customized-dialog-title"
      >
        {modalMode == "complete" ? (
          <>
            <DialogTitle id="customized-dialog-title">알림</DialogTitle>
            <DialogContent dividers>삭제되었습니다.</DialogContent>
            <DialogActions>
              <Button
                variant="contained"
                color="primary"
                type="button"
                onClick={() => {
                  handleModalClose();
                  loadList();
                }}
              >
                확인
              </Button>
            </DialogActions>
          </>
        ) : (
          <>
            <DialogTitle id="customized-dialog-title">알림</DialogTitle>
            <DialogContent dividers>
              삭제 시 연결된 데이터에 문제가 발생할 수 있습니다.
              <br /> 정말 삭제하시겠습니까?
            </DialogContent>
            <DialogActions>
              <Button
                variant="contained"
                onClick={() => handleModalClose()}
                type="button"
              >
                취소
              </Button>
              <Button
                variant="contained"
                onClick={() => handleDelete()}
                color="primary"
                type="button"
              >
                확인
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>
    </>
  );
}
